<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-13 11:18:06
 * @LastEditTime: 2021-01-14 16:16:40
-->

<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartdata() {
      this.renderChart(this.chartdata, this.options);
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>

<style>
</style>